module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }